import React, { useState, useEffect } from 'react'
import { Card, CardBody, Input, Button } from "reactstrap"
import ReactPaginate from 'react-paginate'
import classNames from 'classnames'
import { DatePicker, Spin, message, Modal, Checkbox } from 'antd'
import NextBoxDiaryTable from './NextBoxDiaryTable'
import { getNextBoxDiary, exportNextBoxDiary, exportNextBoxDiaryItems } from '../../../services/api/apiNextBoxDiary'
import moment from 'moment'
import { Link } from 'react-router-dom'

const LIMIT = [
    { name: '20 rows', value: 20 },
    { name: '50 rows', value: 50 },
    { name: '100 rows', value: 100 },
    { name: '200 rows', value: 200 },
]

const { RangePicker } = DatePicker

function NextBoxDiaryPage() {
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(0)
    const [limit, setLimit] = useState(50)
    const [error, setError] = useState('')
    const [date, setDate] = useState({})
    const [listData, setListData] = useState([])
    const [selectedAll, setSelectedAll] = useState(false)
    const [listSelecteds, setListSelecteds] = useState([])
    const [showExportModal, setShowExportModal] = useState(false)
    const [exportType, setExportType] = useState('')
    const [link, setLink] = useState(localStorage.getItem('exportNextBoxesDiaryLink') || '')
    const [linkDailyShip, setLinkDailyShip] = useState(localStorage.getItem('exportDailyShip') || '')
    const [linkBill, setLinkBill] = useState(localStorage.getItem('exportBill') || '')
    const [clearOldSheets, setClearOldSheets] = useState(false)

    const handleChangeLimit = (e) => {
        const { name, value } = e.target
        setLimit(value)
        setPage(1)
    }

    const handlePageClick = (page) => {
        const newPage = page.selected
        setPage(parseInt(newPage) + 1)
    }
    const handleDateChange = (date, dateString) => {
        const [from, to] = dateString
        setDate({ from, to })
        setPage(1)
    }

    const fetchListData = async () => {
        setLoading(true)
        setError('')
        setListSelecteds([])
        try {
            const payload = {
                page: page,
                limit: limit,
            }
            const { from, to } = { ...date }
            if (from && to) payload.date = { from: from, to: to }
            const { data: res } = await getNextBoxDiary(payload)
            const { success, data, message: mes } = { ...res }
            const { items = [], total: totalData } = { ...data }
            if (!success) {
                throw new Error(mes)
            }
            setListData(items)
            setTotal(totalData)
        } catch (error) {
            setError(error.message)
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    const handleShowExportModal = (field) => {
        setExportType(field)
        setShowExportModal(true)
    }

    const handleCloseExportModal = () => {
        setShowExportModal(false)
        setLink(localStorage.getItem('exportNextBoxesDiaryLink') || '')
        setLinkDailyShip(localStorage.getItem('exportDailyShip') || '')
        setLinkBill(localStorage.getItem('exportBill') || '')
        setClearOldSheets(false)
    }

    const handleChangeLink = (field, e) => {
        if (field === 'export') setLink(e.target.value)
        if (field === 'exportDailyShip') setLinkDailyShip(e.target.value)
        if (field === 'exportBill') setLinkBill(e.target.value)
    }

    const exportListData = async () => {
        setLoading(true)
        setError('')
        try {
            const filterSelects = listData.length > 0 ? listData.map(i => moment(i.date).format('DD/MM/YYYY')) : []
            const payload = {
                url: link,
                date: listSelecteds.length > 0 ? listSelecteds : filterSelects.length > 0 ? filterSelects : []
            }
            if (exportType === 'export') {
                payload.url = link
                payload.date = listSelecteds.length > 0 ? listSelecteds : filterSelects.length > 0 ? filterSelects : []
            }
            if (exportType === 'exportDailyShip') {
                payload.url = linkDailyShip
                payload.date = listSelecteds.length > 0 ? listSelecteds : filterSelects.length > 0 ? filterSelects : []
                payload.statisticObject = 'SKU'
            }
            if (exportType === 'exportBill') {
                payload.url = linkBill
                payload.date = date
            }

            if (clearOldSheets) payload.clearOldSheets = clearOldSheets

            const { data: res } = await (exportType === 'exportBill' ? exportNextBoxDiaryItems(payload) : exportNextBoxDiary(payload))
            const { success, data, message: mes } = { ...res }

            if (!success) {
                throw new Error(mes)
            }
            if (exportType === 'export') {
                localStorage.setItem('exportNextBoxesDiaryLink', link)
            }
            if (exportType === 'exportDailyShip') {
                localStorage.setItem('exportDailyShip', linkDailyShip)
            }
            if (exportType === 'exportBill') {
                localStorage.setItem('exportBill', linkBill)
            }
            message.success(`Export thành công.`)
            handleCloseExportModal()
        } catch (error) {
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    const _handleChangeSelectAll = (isActive = false) => {
        if (isActive) {
            const listSelectedId = listData && listData.length > 0 ? listData.map(item => moment(item.date).format('DD/MM/YYYY')) : []
            setListSelecteds(listSelectedId)
            setSelectedAll(true)
        } else {
            setListSelecteds([])
            setSelectedAll(false)
        }
    }

    const _handleSelected = (date, isAdded) => {
        if (isAdded) {
            if (!listSelecteds.includes(date)) {
                setListSelecteds([
                    ...listSelecteds, date,
                ])
                setSelectedAll(listSelecteds.length + 1 === listData.length)
            }
        } else {
            const filtered = listSelecteds.filter(item => item !== date)

            setListSelecteds(filtered)
            setSelectedAll(false)
        }
    }

    const handleChangeCheckbox = (e) => {
        setClearOldSheets(e.target.checked)
    }

    useEffect(() => {
        fetchListData()
    }, [page, limit, date])

    const pages = Math.ceil(total / limit)
    const disableExport = !(listSelecteds && listSelecteds.length > 0) && (!date['from'] || !date['to'])
    const disableExportDailyShip = !(listSelecteds && listSelecteds.length > 0) && (!date['from'] || !date['to'])
    const disableExportBill = (!date['from'] || !date['to'])

    const exportModalTitle = () => {
        if (exportType === 'export' || !exportType) {
            return 'Link Google Sheet'
        }
        if (exportType === 'exportDailyShip') {
            return 'Export Daily Ship'
        }
        if (exportType === 'exportBill') {
            return 'Export Bill'
        }
    }

    const exportLink = () => {
        if (exportType === 'export' || !exportType) {
            return link || ''
        }
        if (exportType === 'exportDailyShip') {
            return linkDailyShip || ''
        }
        if (exportType === 'exportBill') {
            return linkBill || ''
        }
    }

    return (
        <div className='NextBoxDiaryPage'>
            <div className="BackWrapper mb-2">
                <Link to='/next-boxes'><i className='fa fa-chevron-left mr-1' />Next Box</Link>
            </div>
            <Card>
                <div className="CardHeader card-header header-elements-inline">
                    <div className="header-elements d-flex justify-content-between align-items-center w-100">
                        <h1 className='card-title'>Nhật ký đóng thùng</h1>
                        <div className="actions">
                            <div className="d-flex">
                                <Button
                                    color='primary'
                                    className='ml-1'
                                    onClick={() => handleShowExportModal('exportBill')}
                                    disabled={disableExportBill}
                                >
                                    <i className='fa fa-download mr-1' />Export Bill
                                </Button>
                                <Button
                                    color='primary'
                                    className='ml-1'
                                    onClick={() => handleShowExportModal('exportDailyShip')}
                                    disabled={disableExportDailyShip}
                                >
                                    <i className='fa fa-download mr-1' />Export Daily Ship
                                </Button>
                                <Button
                                    color='primary'
                                    className='ml-1'
                                    onClick={() => handleShowExportModal('export')}
                                    disabled={disableExport}
                                >
                                    <i className='fa fa-download mr-1' />Export
                                </Button>
                                <Modal
                                    title={exportModalTitle()}
                                    onCancel={handleCloseExportModal}
                                    onOk={exportListData}
                                    okText='Export'
                                    visible={showExportModal}
                                >
                                    <div>
                                        <label>Link</label>
                                        <Input
                                            placeholder='Link Google Sheet'
                                            onChange={(e) => handleChangeLink(exportType, e)}
                                            value={exportLink()}
                                        />
                                    </div>
                                    <div className='CheckBox mt-2'>
                                        <Checkbox
                                            className='mr-1'
                                            checked={clearOldSheets}
                                            onChange={handleChangeCheckbox}
                                        />
                                        Xóa bản ghi đã tồn tại trong Google Sheet.
                                    </div>
                                    <div className='mt-3'>Share your Google Sheet to <strong>everyone</strong>.
                                    </div>
                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>

                <CardBody>
                    <div className="NextBoxDiaryFilters mb-3 pt-3 pl-3 pr-3">
                        <div className="d-flex align-items-center">
                            <div className="FilterDate mb-3 mr-3">
                                <label className='font-weight-bold d-block'>Ngày rời xưởng</label>
                                <RangePicker
                                    placeholder={['Từ ngày', 'Đến ngày']}
                                    value={[date.from ? moment(date.from, 'DD/MM/YYYY') : '', date.to ? moment(date.to, 'DD/MM/YYYY') : '']}
                                    format={'DD/MM/YYYY'}
                                    onChange={handleDateChange}
                                    style={{ minWidth: 200 }}
                                    ranges={{
                                        'Today': [moment().startOf('day'), moment().endOf('day')],
                                        'Last 7 Days': [moment().subtract(6, 'day').startOf('day'), moment().endOf('day')],
                                        'This Month': [moment().startOf('month').startOf('day'), moment().endOf('month').endOf('day')],
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                        <div className='d-flex'>
                            Đã chọn <strong className='mx-1'>{listSelecteds.length}</strong> ngày
                            {error && <div className="text-danger mx-3">{error}</div>}
                        </div>
                        <div className='d-flex align-items-center'>
                            <div className='d-flex align-items-center mr-3'>
                                <div>Hiển thị</div>
                                <Input
                                    type='select'
                                    value={limit}
                                    name='limit'
                                    onChange={handleChangeLimit}
                                    className='ml-1 mr-1 w-auto'>
                                    {
                                        LIMIT.map(item => {
                                            return <option key={item.value} value={item.value}>{item.name}</option>
                                        })
                                    }
                                </Input>
                            </div>
                            <div>
                                Tổng số <strong>{total}</strong> items
                            </div>
                        </div>
                    </div>
                    <Spin spinning={loading} tip={'Đang lấy dữ liệu...'} size='large'>
                        <NextBoxDiaryTable
                            loading={loading}
                            listData={listData}
                            selectedAll={selectedAll}
                            listSelecteds={listSelecteds}
                            handleChangeSelectAll={_handleChangeSelectAll}
                            handleSelected={_handleSelected}
                            reset={fetchListData}
                        />

                    </Spin>

                    {
                        listData.length > 0 &&
                        <div className="mt-3 float-right">
                            <ReactPaginate
                                forcePage={page - 1}
                                previousLabel='Previous'
                                previousClassName='page-item previous'
                                previousLinkClassName='page-link'
                                nextLabel='Next'
                                nextClassName='page-item next'
                                nextLinkClassName='page-link'
                                breakLabel='...'
                                breakClassName='break-me'
                                pageCount={pages}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={handlePageClick}
                                containerClassName={classNames('pagination', { loading })}
                                pageClassName='page-item'
                                pageLinkClassName='page-link'
                                activeClassName='active' />
                        </div>
                    }
                </CardBody>
            </Card>
        </div>
    )
}

export default NextBoxDiaryPage